import React from 'react'
import Sketch from 'react-p5'

function App() {
  const setup = (p5, canvasParentRef) => {
    p5.createCanvas(500, 500).parent(canvasParentRef)
  }
  
  const draw = p5 => {
    p5.background(100)

    let b = 1;
    while(b < 1000)
    {
        b=b + 5;
        p5.line(500, b, 0, b);
        p5.fill(255);
    }
    let a = 1;
       while(a < 1000){
           a=a + 10;
           p5.ellipse(250, a, 200, a);
           p5.fill(200 - a, 20 - (2 * a), 50 + (a / 4));
       }
  }
  
  return <Sketch setup={setup} draw={draw} />
}

export default App




